/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsExtendedRoutingModule
 * Purpose		: Routing module for OrderDetailsExtended.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OrderDetailsExtendedListComponent } from './OrderDetailsExtendedList.component';
import { OrderDetailsExtendedDetailsComponent } from './OrderDetailsExtendedDetails.component';

const OrderDetailsExtendedRoutes: Routes = [
	{ path: 'OrderDetailsExtended',  component: OrderDetailsExtendedListComponent },
	{ path: 'OrderDetailsExtended/Details/:id', component: OrderDetailsExtendedDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(OrderDetailsExtendedRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class OrderDetailsExtendedRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrderDetailsExtended/OrderDetailsExtended-routing.module.ts